import { render, staticRenderFns } from "./studentCount.vue?vue&type=template&id=57758cad&"
import script from "./studentCount.vue?vue&type=script&lang=js&"
export * from "./studentCount.vue?vue&type=script&lang=js&"
import style0 from "./studentCount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports